/**
 * Buy info
 *
 * Keeps the lines below the add-to-cart button of a rug that depend on the
 * size (delivery time, discount) in step with the selected variation. Each
 * line names the field of the variation data it shows in `data-buy-info`;
 * see Custom_Theme\Setup\Woocommerce::buy_info().
 */

// window.jQuery, not the bundled one: WooCommerce raises found_variation with
// jQuery's .trigger(), which only reaches handlers bound through the same
// jQuery (see bindVariationEvents() in colour-variants.js).
const $ = window.jQuery;

$ && $(function () {
    const $items = $('[data-buy-info]');

    if (!$items.length) {
        return;
    }

    const $form = $items.closest('form.variations_form');

    function show(variation) {
        $items.each(function () {
            const text = (variation && variation[this.dataset.buyInfo]) || '';

            $(this).find('.buy-info__text').text(text);
            this.hidden = !text;
        });
    }

    $form
        .on('found_variation', function (event, variation) {
            show(variation);
        })
        .on('reset_data', function () {
            show(null);
        });

    // Scripts are deferred, so WooCommerce may have picked a variation before
    // this ran.
    const variationId = parseInt($form.find('input[name="variation_id"]').val(), 10);
    const variations = $form.data('product_variations');

    if (variationId && Array.isArray(variations)) {
        show(variations.find((variation) => variation.variation_id === variationId));
    }
});
